/**
 * @owner @Appboy/messaging-experience
 */
import { appRemoteLookupValidators } from "../.generated/appRemoteLookup";
import type { AppRemoteLookupProvider } from "../.generated/appRemoteLookup";

export const appProvider: AppRemoteLookupProvider = {
  mapItemToId: (item) => item.id,
  mapIdToString: (id) => id,
  mapItemToSearchString: (item) => item.name,
  validators: appRemoteLookupValidators,
};
